import CreateSchedule from "./create_schedule";

export default CreateSchedule;
